import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import Modal from '../Modal';
import {
  AccessibilityStatementButtonStyled,
  AccessibilityStatementWrapperStyled,
} from './AccessibilityStatement.styled';

const AccessibilityStatement: React.FC<{ intl: IntlShape }> = ({
  intl: { formatMessage },
}) => {
  const modalButtonElement = (props: {}) => (
    <AccessibilityStatementButtonStyled {...props}>
      {formatMessage({
        id: 'message.accessibilityStatement.button',
        defaultMessage: 'Accessibility Statement',
      })}
    </AccessibilityStatementButtonStyled>
  );
  return (
    <AccessibilityStatementWrapperStyled>
      <Modal
        ariaLabel={formatMessage({
          id: 'message.accessibilityStatement.modalLabel',
        })}
        modalButtonElement={modalButtonElement}
      >
        <div style={{ textAlign: 'left' }}>
          <h1>
            <FormattedMessage id="message.accessibilityStatement.intro.title" />
          </h1>
          <p>
            <FormattedMessage id="message.accessibilityStatement.intro.paragraph1" />
          </p>
          <p>
            <strong>
              <a href={window.location.host}>{window.location.host}</a>
            </strong>
          </p>
          <p>
            <FormattedMessage id="message.accessibilityStatement.intro.paragraph2" />
          </p>
          <p>
            <FormattedMessage id="message.accessibilityStatement.intro.paragraph3" />
          </p>
          <p>
            <FormattedMessage id="message.accessibilityStatement.intro.paragraph4" />
          </p>
          <h2>
            <FormattedMessage id="message.accessibilityStatement.commitment.title" />
          </h2>
          <p>
            <FormattedMessage
              id="message.accessibilityStatement.commitment.paragraph1"
              values={{
                link: (
                  <a href="https://www.w3.org/TR/WCAG21/">
                    Web Content Accessibility Guidelines
                  </a>
                ),
              }}
            />
          </p>
          <p>
            <FormattedMessage id="message.accessibilityStatement.commitment.paragraph2" />
          </p>
          <h2>
            <FormattedMessage id="message.accessibilityStatement.features.title" />
          </h2>
          <p>
            <FormattedMessage id="message.accessibilityStatement.features.paragraph1" />
          </p>
          <ul>
            <li>
              <FormattedMessage id="message.accessibilityStatement.features.listItem1" />
            </li>
            <li>
              <FormattedMessage id="message.accessibilityStatement.features.listItem2" />
            </li>
            <li>
              <FormattedMessage id="message.accessibilityStatement.features.listItem3" />
            </li>
            <li>
              <FormattedMessage id="message.accessibilityStatement.features.listItem4" />
            </li>
            <li>
              <FormattedMessage id="message.accessibilityStatement.features.listItem5" />
            </li>
          </ul>
          <h2>
            <FormattedMessage id="message.accessibilityStatement.compatibility.title" />
          </h2>
          <p>
            <FormattedMessage id="message.accessibilityStatement.compatibility.paragraph1" />
          </p>
          <p>
            <FormattedMessage
              id="message.accessibilityStatement.compatibility.browsers"
              values={{ strong: (el: string) => <strong>{el}</strong> }}
            />
          </p>
          <p>
            <FormattedMessage
              id="message.accessibilityStatement.compatibility.assistiveTech"
              values={{ strong: (el: string) => <strong>{el}</strong> }}
            />
          </p>
          <h2>
            <FormattedMessage id="message.accessibilityStatement.limitations.title" />
          </h2>
          <p>
            <FormattedMessage id="message.accessibilityStatement.limitations.paragraph1" />
          </p>
          <ul>
            <li>
              <FormattedMessage id="message.accessibilityStatement.limitations.listItem1" />
            </li>
          </ul>

          <h2>
            <FormattedMessage id="message.accessibilityStatement.contact.title" />
          </h2>
          <p>
            <FormattedMessage id="message.accessibilityStatement.contact.paragraph1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="message.accessibilityStatement.contact.contactForm.title" />
              <a href="https://support.solarisgroup.com/hc/de/requests/new">
                <FormattedMessage id="message.accessibilityStatement.contact.contactForm.cta" />
              </a>
            </strong>
            <FormattedMessage id="message.accessibilityStatement.contact.contactForm.supplementary" />
          </p>
          <p>
            <FormattedMessage id="message.accessibilityStatement.contact.paragraph2" />
          </p>
          <h2>
            <FormattedMessage id="message.accessibilityStatement.lastReview.title" />
          </h2>
          <p>
            <FormattedMessage id="message.accessibilityStatement.lastReview.paragraph1" />
          </p>
        </div>
      </Modal>
    </AccessibilityStatementWrapperStyled>
  );
};

export default injectIntl(AccessibilityStatement);
